import React from 'react';
import {put, takeEvery} from 'redux-saga/effects';

import {displayToast, notifyUser} from './actions';
import Message from 'components/Notifications/Message';


export default function* () {
    yield takeEvery(notifyUser, toast);
}

function* toast(action) {
    let type = action.payload.type;

    const message = <Message type={type}>{action.payload.message}</Message>;
    yield put(displayToast(message, type));
}